"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMembershipExpirationDate = exports.findPerPurchaseViolation = exports.getAvailableAddOnCount = exports.getAvailableAddOnRates = exports.hasAddOnRates = exports.getTicketRates = exports.getAddOnRates = exports.isAddOnRate = void 0;
const ticketing_1 = require("../enums/ticketing");
const dates_1 = require("./dates");
const isAddOnRate = (rate) => Boolean(rate.isAddOn);
exports.isAddOnRate = isAddOnRate;
const getAddOnRates = (rates) => (rates ?? []).filter(exports.isAddOnRate);
exports.getAddOnRates = getAddOnRates;
const getTicketRates = (rates) => (rates ?? []).filter((rate) => !(0, exports.isAddOnRate)(rate));
exports.getTicketRates = getTicketRates;
const hasAddOnRates = (rates) => (rates ?? []).some(exports.isAddOnRate);
exports.hasAddOnRates = hasAddOnRates;
const getAvailableAddOnRates = (rates) => (0, exports.getAddOnRates)(rates).filter((rate) => !rate.isHidden);
exports.getAvailableAddOnRates = getAvailableAddOnRates;
const getAvailableAddOnCount = (rates) => (0, exports.getAvailableAddOnRates)(rates).length;
exports.getAvailableAddOnCount = getAvailableAddOnCount;
const findPerPurchaseViolation = (unitsByRateId, ratesById) => {
    for (const [rateId, units] of unitsByRateId) {
        const rate = ratesById.get(rateId);
        if (!rate) {
            continue;
        }
        const minimumToBuy = rate.minimumToBuy ?? 0;
        if (minimumToBuy > 0 && units < minimumToBuy) {
            return { code: "rate_below_minimum_per_purchase", rateId, units, minimumToBuy };
        }
        const maximumToBuy = rate.maximumToBuy ?? 0;
        if (maximumToBuy > 0 && units > maximumToBuy) {
            return { code: "rate_above_maximum_per_purchase", rateId, units, maximumToBuy };
        }
    }
    return null;
};
exports.findPerPurchaseViolation = findPerPurchaseViolation;
const getMembershipExpirationDate = ({ membershipValidityPeriod, expirationDate, paymentDate, }) => {
    if (membershipValidityPeriod === ticketing_1.MembershipValidityPeriod.OneYearAfterPayment) {
        return (0, dates_1.getDatePlusNYears)(paymentDate || new Date(), 1);
    }
    else if (membershipValidityPeriod === ticketing_1.MembershipValidityPeriod.OneMonthAfterPayment) {
        return (0, dates_1.getDatePlusNMonths)(paymentDate || new Date(), 1);
    }
    else if (membershipValidityPeriod === ticketing_1.MembershipValidityPeriod.AtDate && expirationDate) {
        return (0, dates_1.getNextOccurrenceWithThreeMonthGracePeriod)(new Date(expirationDate));
    }
    return null;
};
exports.getMembershipExpirationDate = getMembershipExpirationDate;
